import echarts from '@/config/echarts/index.js'
export function getSlideLiveOption () {
  const data = []
  return {
    color: ['#49B2FF', '#5DF5EC', '#A3CAFF'],
    legend: {
      show: true,
      top: 0,
      itemWidth: 14,
      itemHeight: 9,
      itemGap: 20,
      icon: 'circle',
      textStyle: {
        color: '#FFF',
        fontSize: '0.8rem'
      }
    },
    grid: {
      left: 50,
      right: 100,
      top: 30,
      bottom: 20
    },
    tooltip: {
      trigger: 'axis',
      textStyle: {
        fontStyle: '0.63vw' // 文字字体的风格（'normal'，无样式；'italic'，斜体；'oblique'，倾斜字体）
      },
      formatter: function (params) {
        var result = ''
        if (params.length === 0) {
          return result
        }
        var dotHtml = '<span style="display:inline-block;margin-right:0.26vw;border-radius:0.52vw;width:0.52vw;height:0.52vw;background-color:#5c7bd9"></span>' // 定义第一个数据前的圆点颜色
        var dotHtml2 = '<span style="display:inline-block;margin-right:0.26vw;border-radius:0.52vw;width:0.52vw;height:0.52vw;background-color:#99cc66"></span>' // 定义第二个数据前的圆点颜色
        var dotHtml3 = '<span style="display:inline-block;margin-right:0.26vw;border-radius:0.52vw;width:0.52vw;height:0.52vw;background-color:#A3CAFF"></span>'
        result += params[0].axisValue

        for (let i = 0; i < params.length; i++) {
          const seriesName = params[i].seriesName
          if (seriesName === '温度') {
            result += '</br>' + dotHtml + ' 温度 ' + params[i].data + '℃'
            continue
          }
          if (seriesName === '雨量') {
            result += '</br>' + dotHtml2 + ' 雨量 ' + params[i].data + 'mm'
            continue
          }
          if (seriesName === '风速') {
            result += '</br>' + dotHtml3 + ' 风速 ' + params[i].data + 'm/s'
            continue
          }
        }
        return result
      }
    },
    xAxis: {
      data: data,
      axisTick: { length: 5 },
      axisLine: {
        onZero: false
      },
      axisLabel: {
        color: '#FFF',
        fontSize: '0.9rem'
      }
    },
    yAxis: [
      {
        type: 'value',
        name: '(℃)',
        nameLocation: 'end',
        position: 'left',
        nameTextStyle: {
          color: '#FFF',
          fontSize: '0.9rem',
          align: 'right'
        },
        splitLine: {
          show: false
        },
        splitNumber: 4,
        axisLabel: {
          color: '#FFF',
          fontSize: '0.9rem'
        }
      },
      {
        type: 'value',
        name: '(mm)',
        nameLocation: 'end',
        position: 'right',
        show: true,
        nameTextStyle: {
          color: '#FFF',
          fontSize: '0.9rem',
          align: 'left'
        },
        splitLine: {
          show: false
        },
        axisLabel: {
          color: '#FFF',
          fontSize: '0.9rem'
        }
      },
      {
        type: 'value',
        name: '(m/s)',
        nameLocation: 'end',
        position: 'right',
        show: true,
        offset: 50,
        nameTextStyle: {
          color: '#FFF',
          fontSize: '0.9rem',
          align: 'left'
        },
        splitLine: {
          show: false
        },
        axisLabel: {
          color: '#FFF',
          fontSize: '0.9rem'
        }
      }
    ],
    series: [
      {
        name: '温度',
        type: 'line',
        yAxisIndex: 0,
        smooth: true,
        data: [],
        label: {
          show: true,
          position: 'top',
          fontSize: '0.75rem',
          color: '#FFF'
        },
        markLine: { symbol: 'none', label: { show: false }, lineStyle: { color: '#fff' }, data: [{ name: '中间线', xAxis: '00:00' }] },
        itemStyle: {
          normal: {
            lineStyle: {
              width: 0.7// 0.1的线条是非常细的了
            }
          }
        },
        areaStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: 'rgba(88, 143, 249, 0.85)'
            },
            {
              offset: 1,
              color: 'rgba(2, 86, 247, 0)'
            }
          ])
        }
      },
      {
        name: '雨量',
        type: 'bar',
        barWidth: '12rem',
        width: '20px',
        yAxisIndex: 1,
        data: [],
        label: {
          show: false,
          position: 'top',
          fontSize: '0.75rem',
          color: '#FFF'
        },
        markLine: { symbol: 'none', label: { show: false }, lineStyle: { color: '#fff' }, data: [{ name: '中间线', xAxis: '00:00' }] },
        color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
          {
            offset: 1,
            color: 'rgba(88, 223, 217, 1)'
          },
          {
            offset: 0.5,
            color: 'rgba(88, 223, 217, 0.5)'
          },
          {
            offset: 0,
            color: 'rgba(255, 255, 255, 0)'
          }
        ]),
        itemStyle: {
          normal: {
            barBorderRadius: [2, 2, 0, 0]
          }
        }
      },
      {
        name: '风速',
        yAxisIndex: 2,
        data: [],
        type: 'line',
        symbol: 'triangle',
        symbolSize: 10,
        smooth: true,
        lineStyle: {
          color: '#A3CAFF',
          width: 2
        },
        itemStyle: {
          borderWidth: 0,
          borderColor: '#A3CAFF',
          color: '#A3CAFF'
        },
        markLine: { symbol: 'none', label: { show: false }, lineStyle: { color: '#fff' }, data: [{ name: '中间线', xAxis: '00:00' }] },
        areaStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: 'rgba(10, 94, 255, 0.2)'
            },
            {
              offset: 1,
              color: 'rgba(10, 94, 255, 0)'
            }
          ])
        }
      }
    ]
  }
}

export function getZjzSlideLiveOption () {
  const data = []
  return {
    color: ['#49B2FF', '#5DF5EC', '#A3CAFF'],
    legend: {
      show: true,
      top: 0,
      itemWidth: 14,
      itemHeight: 9,
      itemGap: 20,
      icon: 'circle',
      textStyle: {
        color: '#FFF',
        fontSize: '0.8rem'
      }
    },
    grid: {
      left: 50,
      right: 100,
      top: 30,
      bottom: 20
    },
    tooltip: {
      trigger: 'axis',
      textStyle: {
        fontStyle: '0.63vw' // 文字字体的风格（'normal'，无样式；'italic'，斜体；'oblique'，倾斜字体）
      },
      formatter: function (params) {
        var result = ''
        if (params.length === 0) {
          return result
        }
        var dotHtml = '<span style="display:inline-block;margin-right:0.26vw;border-radius:0.52vw;width:0.52vw;height:0.52vw;background-color:#5c7bd9"></span>' // 定义第一个数据前的圆点颜色
        var dotHtml2 = '<span style="display:inline-block;margin-right:0.26vw;border-radius:0.52vw;width:0.52vw;height:0.52vw;background-color:#99cc66"></span>' // 定义第二个数据前的圆点颜色
        var dotHtml3 = '<span style="display:inline-block;margin-right:0.26vw;border-radius:0.52vw;width:0.52vw;height:0.52vw;background-color:#A3CAFF"></span>'
        result += params[0].axisValue

        for (let i = 0; i < params.length; i++) {
          const seriesName = params[i].seriesName
          if (seriesName === '温度') {
            result += '</br>' + dotHtml + ' 温度 ' + params[i].data + '℃'
            continue
          }
          if (seriesName === '相对湿度') {
            result += '</br>' + dotHtml2 + ' 相对湿度 ' + params[i].data + '%'
            continue
          }
          if (seriesName === '光照强度') {
            result += '</br>' + dotHtml3 + ' 光照强度 ' + params[i].data + 'lux'
            continue
          }
        }
        return result
      }
    },
    xAxis: {
      data: data,
      axisTick: { length: 5 },
      axisLine: {
        onZero: false
      },
      axisLabel: {
        color: '#FFF',
        fontSize: '0.9rem'
      }
    },
    yAxis: [
      {
        type: 'value',
        name: '(℃)',
        nameLocation: 'end',
        position: 'left',
        nameTextStyle: {
          color: '#FFF',
          fontSize: '0.9rem',
          align: 'right'
        },
        splitLine: {
          show: false
        },
        splitNumber: 4,
        axisLabel: {
          color: '#FFF',
          fontSize: '0.9rem'
        }
      },
      {
        type: 'value',
        name: '  (%)',
        nameLocation: 'end',
        position: 'right',
        show: true,
        nameTextStyle: {
          color: '#FFF',
          fontSize: '0.9rem',
          align: 'left'
        },
        splitLine: {
          show: false
        },
        axisLabel: {
          color: '#FFF',
          fontSize: '0.9rem'
        }
      },
      {
        type: 'value',
        name: ' (lux)',
        nameLocation: 'end',
        position: 'right',
        show: true,
        offset: 50,
        nameTextStyle: {
          color: '#FFF',
          fontSize: '0.9rem',
          align: 'left'
        },
        splitLine: {
          show: false
        },
        axisLabel: {
          color: '#FFF',
          fontSize: '0.9rem'
        }
      }
    ],
    series: [
      {
        name: '温度',
        type: 'line',
        yAxisIndex: 0,
        smooth: true,
        data: [],
        label: {
          show: true,
          position: 'top',
          fontSize: '0.75rem',
          color: '#FFF'
        },
        markLine: { symbol: 'none', label: { show: false }, lineStyle: { color: '#fff' }, data: [{ name: '中间线', xAxis: '00:00' }] },
        itemStyle: {
          normal: {
            lineStyle: {
              width: 0.7// 0.1的线条是非常细的了
            }
          }
        }
        // areaStyle: {
        //   color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
        //     {
        //       offset: 0,
        //       color: 'rgba(88, 143, 249, 0.85)'
        //     },
        //     {
        //       offset: 1,
        //       color: 'rgba(2, 86, 247, 0)'
        //     }
        //   ])
        // }
      },
      {
        name: '相对湿度',
        type: 'line',
        barWidth: '12rem',
        width: '20px',
        yAxisIndex: 1,
        data: [],
        label: {
          show: false,
          position: 'top',
          fontSize: '0.75rem',
          color: '#FFF'
        },
        markLine: { symbol: 'none', label: { show: false }, lineStyle: { color: '#fff' }, data: [{ name: '中间线', xAxis: '00:00' }] },
        color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
          {
            offset: 1,
            color: 'rgba(88, 223, 217, 1)'
          },
          {
            offset: 0.5,
            color: 'rgba(88, 223, 217, 0.5)'
          },
          {
            offset: 0,
            color: 'rgba(255, 255, 255, 0)'
          }
        ]),
        itemStyle: {
          normal: {
            barBorderRadius: [2, 2, 0, 0]
          }
        }
      },
      {
        name: '光照强度',
        yAxisIndex: 2,
        data: [],
        type: 'line',
        // symbol: 'triangle',
        // symbolSize: 10,
        smooth: true,
        lineStyle: {
          color: '#A3CAFF',
          width: 2
        },
        itemStyle: {
          borderWidth: 0,
          borderColor: '#A3CAFF',
          color: '#A3CAFF'
        },
        markLine: { symbol: 'none', label: { show: false }, lineStyle: { color: '#fff' }, data: [{ name: '中间线', xAxis: '00:00' }] },
        areaStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: 'rgba(10, 94, 255, 0.2)'
            },
            {
              offset: 1,
              color: 'rgba(10, 94, 255, 0)'
            }
          ])
        }
      }
    ]
  }
}

export function getScZjzSlideLiveOption () {
  const data = []
  return {
    // color: ['#49B2FF', '#5DF5EC', '#A3CAFF'],
    legend: {
      show: true,
      top: 0,
      itemWidth: 14,
      itemHeight: 9,
      itemGap: 20,
      icon: 'circle',
      textStyle: {
        color: '#FFF',
        fontSize: '0.8rem'
      }
    },
    grid: {
      left: 50,
      right: 100,
      top: 30,
      bottom: 20
    },
    tooltip: {
      trigger: 'axis',
      textStyle: {
        fontStyle: '0.63vw' // 文字字体的风格（'normal'，无样式；'italic'，斜体；'oblique'，倾斜字体）
      },
      formatter: function (params) {
        var result = ''
        if (params.length === 0) {
          return result
        }
        // var dotHtml = '<span style="display:inline-block;margin-right:0.26vw;border-radius:0.52vw;width:0.52vw;height:0.52vw;background-color:#5c7bd9"></span>' // 定义第一个数据前的圆点颜色
        // var dotHtml2 = '<span style="display:inline-block;margin-right:0.26vw;border-radius:0.52vw;width:0.52vw;height:0.52vw;background-color:#99cc66"></span>' // 定义第二个数据前的圆点颜色
        // var dotHtml3 = '<span style="display:inline-block;margin-right:0.26vw;border-radius:0.52vw;width:0.52vw;height:0.52vw;background-color:#A3CAFF"></span>'
        result += params[0].axisValue
        console.log('params', params)
        for (let i = 0; i < params.length; i++) {
          const seriesName = params[i].seriesName
          if (seriesName === '水面温度') {
            result += '</br>' + params[i].marker + ' 温度 ' + params[i].data + '℃'
            continue
          }
          if (seriesName === '1m水温') {
            result += '</br>' + params[i].marker + ' 相对湿度 ' + params[i].data + '%'
            continue
          }
          if (seriesName === '2m水温') {
            result += '</br>' + params[i].marker + ' 光照强度 ' + params[i].data + 'lux'
            continue
          }
          if (seriesName === 'ph') {
            result += '</br>' + params[i].marker + ' ph ' + params[i].data
            continue
          }
          if (seriesName === '溶解氧') {
            result += '</br>' + params[i].marker + ' 溶解氧 ' + params[i].data + 'mg/L'
            continue
          }
          if (seriesName === '氨氮') {
            result += '</br>' + params[i].marker + ' 氨氮 ' + params[i].data + 'mg/L'
            continue
          }
        }
        return result
      }
    },
    xAxis: {
      data: data,
      axisTick: { length: 5 },
      axisLine: {
        // onZero: false
      },
      axisLabel: {
        color: '#FFF',
        fontSize: '0.9rem'
      }
    },
    yAxis: [
      {
        type: 'value',
        name: '(℃)',
        nameLocation: 'end',
        position: 'left',
        nameTextStyle: {
          color: '#FFF',
          fontSize: '0.9rem',
          align: 'right'
        },
        splitLine: {
          show: false
        },
        splitNumber: 4,
        axisLabel: {
          color: '#FFF',
          fontSize: '0.9rem'
        }
      },
      {
        type: 'value',
        name: '(mg/L)',
        nameLocation: 'end',
        position: 'right',
        show: true,
        nameTextStyle: {
          color: '#FFF',
          fontSize: '0.9rem',
          align: 'left'
        },
        splitLine: {
          show: false
        },
        axisLabel: {
          color: '#FFF',
          fontSize: '0.9rem'
        }
      },
      {
        type: 'value',
        name: '',
        nameLocation: 'end',
        position: 'right',
        show: true,
        offset: 50,
        nameTextStyle: {
          color: '#FFF',
          fontSize: '0.9rem',
          align: 'left'
        },
        splitLine: {
          show: false
        },
        axisLabel: {
          color: '#FFF',
          fontSize: '0.9rem'
        }
      }
    ],
    series: [
      {
        name: '水面温度',
        type: 'line',
        yAxisIndex: 0,
        smooth: true,
        data: [],
        label: {
          show: true,
          position: 'top',
          fontSize: '0.75rem',
          color: '#FFF'
        },
        markLine: { symbol: 'none', label: { show: false }, lineStyle: { color: '#fff' }, data: [{ name: '中间线', xAxis: '00:00' }] },
        itemStyle: {
          normal: {
            lineStyle: {
              width: 0.7// 0.1的线条是非常细的了
            }
          }
        }
      },
      {
        name: '1m水温',
        type: 'line',
        yAxisIndex: 0,
        smooth: true,
        data: [],
        label: {
          show: true,
          position: 'top',
          fontSize: '0.75rem',
          color: '#FFF'
        },
        markLine: { symbol: 'none', label: { show: false }, lineStyle: { color: '#fff' }, data: [{ name: '中间线', xAxis: '00:00' }] },
        itemStyle: {
          normal: {
            lineStyle: {
              width: 0.7// 0.1的线条是非常细的了
            }
          }
        }
      },
      {
        name: '2m水温',
        type: 'line',
        yAxisIndex: 0,
        smooth: true,
        data: [],
        label: {
          show: true,
          position: 'top',
          fontSize: '0.75rem',
          color: '#FFF'
        },
        markLine: { symbol: 'none', label: { show: false }, lineStyle: { color: '#fff' }, data: [{ name: '中间线', xAxis: '00:00' }] },
        itemStyle: {
          normal: {
            lineStyle: {
              width: 0.7// 0.1的线条是非常细的了
            }
          }
        }
      },
      {
        name: 'ph',
        type: 'line',
        yAxisIndex: 2,
        smooth: true,
        data: [],
        label: {
          show: true,
          position: 'top',
          fontSize: '0.75rem',
          color: '#FFF'
        },
        markLine: { symbol: 'none', label: { show: false }, lineStyle: { color: '#fff' }, data: [{ name: '中间线', xAxis: '00:00' }] },
        itemStyle: {
          normal: {
            lineStyle: {
              width: 0.7// 0.1的线条是非常细的了
            }
          }
        }
      },
      {
        name: '溶解氧',
        type: 'line',
        yAxisIndex: 1,
        smooth: true,
        data: [],
        label: {
          show: true,
          position: 'top',
          fontSize: '0.75rem',
          color: '#FFF'
        },
        markLine: { symbol: 'none', label: { show: false }, lineStyle: { color: '#fff' }, data: [{ name: '中间线', xAxis: '00:00' }] },
        itemStyle: {
          normal: {
            lineStyle: {
              width: 0.7// 0.1的线条是非常细的了
            }
          }
        }
      },
      {
        name: '氨氮',
        type: 'line',
        yAxisIndex: 1,
        smooth: true,
        data: [],
        label: {
          show: true,
          position: 'top',
          fontSize: '0.75rem',
          color: '#FFF'
        },
        markLine: { symbol: 'none', label: { show: false }, lineStyle: { color: '#fff' }, data: [{ name: '中间线', xAxis: '00:00' }] },
        itemStyle: {
          normal: {
            lineStyle: {
              width: 0.7// 0.1的线条是非常细的了
            }
          }
        }
      }
    ]
  }
}

export function getDaysForecastOption () {
  const data = []
  return {
    title: {},
    grid: {
      left: '15px',
      right: '15px',
      bottom: '20px',
      top: '22%'
    },
    tooltip: {
      trigger: 'axis'
    },
    xAxis: {
      show: false,
      boundaryGap: false,
      data: data
    },
    yAxis: {
      show: false
    },
    series: [{
      type: 'line',
      data: [],
      label: {
        show: true,
        position: 'top',
        fontSize: '0.75rem',
        color: '#FFF'
      }
    }, {
      type: 'line',
      data: [],
      label: {
        show: true,
        position: 'bottom',
        fontSize: '0.75rem',
        color: '#FFF'
      }
    }]
  }
}
